/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Defines a value range constraint for each of the attribute
 * @export
 * @interface ParameterLimitConstraint
 */
export interface ParameterLimitConstraint {
    /**
     * Name of the attribute to which the constraint applies
     */
    attribute?: string;
    /**
     * Minimum value allowed of the parameter, type bool, int or double
     */
    min?: object | null;
    /**
     * Maximum value allowed of the parameter, type bool, int or double
     */
    max?: object | null;
    /**
     * Whether the parameter is allowed to be set or not
     */
    allowed?: boolean | null;
}

/**
 * Check if a given object implements the ParameterLimitConstraint interface.
 */
export function instanceOfParameterLimitConstraint(value: object): value is ParameterLimitConstraint {
    return true;
}

export function ParameterLimitConstraintFromJSON(json: any): ParameterLimitConstraint {
    return ParameterLimitConstraintFromJSONTyped(json, false);
}

export function ParameterLimitConstraintFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterLimitConstraint {
    if (json == null) {
        return json;
    }
    return {
        
        'attribute': json['attribute'] == null ? undefined : json['attribute'],
        'min': json['min'] === undefined ? undefined : json['min'] === null ? null : json['min'],
        'max': json['max'] === undefined ? undefined : json['max'] === null ? null : json['max'],
        'allowed': json['allowed'] === undefined ? undefined : json['allowed'] === null ? null : json['allowed'],
    };
}

export function ParameterLimitConstraintToJSON(json: any): ParameterLimitConstraint {
    return ParameterLimitConstraintToJSONTyped(json, false);
}

export function ParameterLimitConstraintToJSONTyped(value?: ParameterLimitConstraint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attribute': value['attribute'],
        'min': value['min'],
        'max': value['max'],
        'allowed': value['allowed'],
    };
}

